// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";


// Stateful components

export class DataLoader extends React.Component{

    //
    // Lifecycle
    //

    constructor(props) {
        super(props);

        this.state = {
            'is_loading': false,
            'has_mounted': false,
            'top_page': null
        };

        // Binds
        this.gatekeeperDataSuccess = this.gatekeeperDataSuccess.bind(this);
    }

    componentDidMount() {
        var this_component = this;

        // Indicate that the component is ready
        this_component['is_mounted'] = true;
        
        // Get page data
        this_component.getPageData();
    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;

        // New Current Page
        var current_page = this_component['props']['current_page'];
        if(current_page !== prev_props['current_page']) {
            // Get page data
            this_component.getPageData();
        }
    }

    componentWillUnmount() {
        var this_component = this;
        this_component['is_mounted'] = false;
    }


    //
    // Helpers
    //

    getPageData() {
        var this_component = this;
        var top_page = this_component['state']['top_page'];
        var current_page = this_component['props']['current_page'];
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var current_page_data = helpers.getPageBySlug(current_page);
        var gatekeeper_data = '';
        
        if (current_page_data) {
            gatekeeper_data = current_page_data['gatekeeper_data'];
            var ia_level = current_page_data['ia_level'];

            if(top_page !== current_page) {
                var new_top_page = current_page;

                if(ia_level !== 1) {
                    new_top_page = current_page_data['parent'];
                }

                this_component.setState({
                    'top_page': new_top_page
                });
            }
        }
        

        if(gatekeeper_data !== '') {
            var sources_list = gatekeeper_data.split('; ');
            var force_refresh = false;
            var successCallback = this_component.gatekeeperDataSuccess;

            this_component.setState({
                'is_loading': true
            });
            
            helpers.processGatekeeperSources(sources_list, force_refresh, successCallback);
        }
    }

    // Stop the loading display and reveal page content
    gatekeeperDataSuccess() {
        var this_component = this;
        var is_mounted = this_component['is_mounted'];
        
        // Safety check
        if(is_mounted) {
            this_component.setState({
                'is_loading': false
            });
        }
    }


    //
    // Render
    //

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var portal_config = portal_context['configuration'];
        var is_loading = this_component['state']['is_loading'];
        var is_mounted = this_component['is_mounted'];
        var loading_image = portal_config['images']['loader.gif']['url'];

        if(is_loading) {
            return (
                <div className="loading__wrapper">
                    <img src={loading_image} alt="Loading..." />
                </div>
            )
        }

        if(is_mounted) {
            return this_component['props']['children'];
        }

        return null;        
    }
}

DataLoader.contextType = PortalContext;
